import { APP__PLUGINS } from "../Plugins.js";
import { LAYOUTS } from "../_Layouts.js";

export const CONFIG_PLUGIN = Object.freeze({
  ...APP__PLUGINS,
  CONTEXTS: { HAS__NOTIFY_CONTEXT: LAYOUTS.CONTEXTS?.HAS_TOASTER_CONTEXT === true },
  TEMPLATES: { HAS__SHOW_APP_TOASTER_NOTIFY_TEST: false, HAS__TEMPLATE_PREVIEW_REMEMBER: true },
});
